<div class="flex flex-column align-items-center justify-content-between p-4 big-screens-max-width">
    <!-- Header -->
    <div class="w-full mb-4">
        <div class="flex align-items-center gap-3 mb-2">
            <i class="pi pi-calculator text-2xl text-primary"></i>
            <h2 class="m-0 text-2xl font-semibold">Calculate Premo Dashboard</h2>
        </div>
        <p class="text-600 m-0">Generate and view the Premo analysis dashboard for this patient</p>
    </div>

    <!-- Loading State -->
    <div *ngIf="uiState?.isLoading" class="w-full text-center py-8">
        <div class="flex flex-column align-items-center gap-3">
            <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
            <h3 class="text-500 m-0">Calculating Premo Dashboard...</h3>
            <p class="text-500 m-0">Please wait while we generate your dashboard</p>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="uiState?.error && !uiState?.isLoading" class="w-full text-center py-8">
        <div class="flex flex-column align-items-center gap-3">
            <i class="pi pi-exclamation-triangle text-4xl text-red-500"></i>
            <h3 class="text-500 m-0">Error Loading Dashboard</h3>
            <p class="text-500 m-0">{{ uiState?.error }}</p>
            <button pButton label="Try Again" icon="pi pi-refresh" class="p-button-outlined"
                (click)="facade.initializeCalculatePremo(orgId, patientId)">
            </button>
        </div>
    </div>

    <!-- Dashboard iframe -->
    <div *ngIf="uiState?.dashboardUrl && !uiState?.isLoading && !uiState?.error" class="w-full h-full">
        <div class="surface-card border-round-xl shadow-2 p-0 overflow-hidden">
            <iframe [src]="getSafeDashboardUrl()" class="w-full border-none" style="height: 85vh;" frameborder="0"
                allowfullscreen>
            </iframe>
        </div>
    </div>
</div>